import type { BindingTargetKind } from './accessBindingTargets';

export type AccessBindingRequiredFields = {
  subjectRefs: readonly string[];
  roleName: string;
  targetKind: BindingTargetKind;
  targetRef: string;
};

export type AccessBindingRequiredFieldErrors = {
  missingSubjects: boolean;
  missingRole: boolean;
  missingTarget: boolean;
};

export function validateAccessBindingRequiredFields(
  fields: AccessBindingRequiredFields,
): AccessBindingRequiredFieldErrors {
  return {
    missingSubjects: fields.subjectRefs.length === 0,
    missingRole: fields.roleName.trim().length === 0,
    missingTarget:
      fields.targetKind === 'Project' && fields.targetRef.trim().length === 0,
  };
}
